'use client';
import Button from '@/components/button';
import CustomVoucherIcon from '@/components/icons/customVoucherIcon';
import { translate } from '@/i18n';

export const VoucherButton = () => {
  return (
    <Button
      variant="contained"
      color="primary"
      className="mb-5 w-50"
      aria-hidden="true"
      tabIndex={-1}
    >
      <CustomVoucherIcon className="size-6 mr-2" />
      <p className="text-xs text-(--mui-palette-text-contrast)">{translate('have-voucher')}</p>
    </Button>
  );
};
